
import { defineComponent, ref } from 'vue';

import { ApplyService } from '@/services/apply.service';
import { useService } from '@kaokei/use-vue-service';

export default defineComponent({
  name: 'ApplyBanner',
  setup() {
    const applyService = useService(ApplyService);

    const ruleVisible = ref(false);

    return {
      applyService,
      ruleVisible,
    };
  },
});
